import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled/macro';
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-bottom: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    padding-bottom: 4px;\n"])));
var templateObject_1;
